<ng-container *transloco="let t">
  <form [formGroup]="inputForm">
    <div>
      <!-- General data card-->
      <app-admin-card-with-title
        [cardTitle]="t('event.item.generalData')" [showToggleButton]="false" [removeTopMargin]="true">
        <div class="row">
          <div class="col-12 col-xl-6 pe-3 pe-md-4">
            <div class="col-xl pb-3">
              @if (isAdministrator || isOrgAdministrator) {
                <app-select formControlName="organiserId"
                            [items]="organisers" [valueKey]="'id'" [labelKey]="'name'"
                            label="app.common.organizer"/>
              }
            </div>
            <div class="row pb-3">
              <div class="col-xl-6">
                <!-- Default language dropdown -->
                <app-select formControlName="defaultLanguage"
                            [items]="languages" [valueKey]="'id'" [labelKey]="'code'"
                            [labelKeyPrefix]="'app.common.language.'" label="event.item.defaultLanguage"/>
              </div>
              <!-- Additional lang-->
              <div class="col-xl-6">
                <app-multiselect-dropdown [options]="getOptions()" [formControlName]="'extraLanguages'" [isDropdownListFullWidth]="true"
                                          [dropdownLabel]="t('event.item.extraLanguage')"/>
              </div>
            </div>
            <div class="pb-3">
              <app-language-input [inputForm]="inputForm"
                                  [defaultLanguage]="inputForm.controls['defaultLanguage'].value"
                                  [extraLanguages]="inputForm.controls['extraLanguages'].value" [hrKey]="'name'"
                                  [enKey]="'nameEng'"
                                  [srKey]="'nameSr'"
                                  [bsKey]="'nameBs'"
                                  [itKey]="'nameIta'" [siKey]="'nameSlo'" [hrLabel]="'event.item.nameCro'"
                                  [enLabel]="'event.item.nameEn'" [bsLabel]="'event.item.nameBs'" [srLabel]="'event.item.nameSr'" [itLabel]="'event.item.nameIt'"
                                  [siLabel]="'event.item.nameSlo'"/>
            </div>
            <div class="row pt-3">
              <div class="col-12">
                <div class="d-flex align-items-start mb-3">
                  <div class="col-4">
                    <app-checkbox formControlName="roundsEnabled" [label]="t('league.details.roundsEnabled')"/>
                  </div>
                  <div class="info-box d-flex align-items-start">
                    <i class="bi bi-info-circle info-icon" ngbTooltip="{{ t('league.details.roundsEnabled.tooltip') }}"
                       placement="top"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6 border-start border-md-start-0 ps-3 ps-xl-4">
            <div class="row">
              <div class="col-xl-6">
                <app-date-time-input formControlName="start" [displayTime]="true"
                                     [label]="t('league.details.start.date')"
                                     [maxDate]="inputForm.controls['end'].value">
                </app-date-time-input>
              </div>
              <div class="col-xl-6">
                <app-date-time-input [label]="t('league.details.end.date')"
                                     formControlName="end"
                                     [displayTime]="true"
                                     [minDate]="inputForm.controls['start'].value">

                </app-date-time-input>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-xl-6">
                <!-- Max number of events -->
                <app-input type="number" formControlName="maxNumberOfEvents" label="league.details.maxNumberOfEvents"
                           cssClass="flex-grow-1" [min]="1" [max]="1000"/>
              </div>
              <!-- League sport -->
              <div class="col-xl-6">
                <app-select formControlName="sportId" [items]="sports"
                            [valueKey]="'id'" [labelKey]="'id'" [labelKeyPrefix]="'app.common.sports.'"
                            label="league.details.sport"/>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-xl-6">
                <app-multiselect-dropdown [options]="countriesOptions"
                                          [maxItemsDisplay]="2"
                                          [isDropdownListFullWidth]="true"
                                          formControlName="countries"
                                          [dropdownLabel]="t('app.common.country')"/>
              </div>
              <div class="col-xl-6">
                <app-select formControlName="categoryId" [items]="categories"
                            valueKey="id" [labelKey]="'name'" label="app.common.category"/>

              </div>
            </div>
            <div class="row pt-3">
              <div class="col-6">
                <app-input formControlName="officialMail" label="league.details.official.league.mail"/>
              </div>
              <div class="col-6">
                <app-input formControlName="officialWebsite" label="league.overview.official.league.page"/>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-xl-6 pt-xl-0 pt-3">
            <div class="field-title mt-3">
                  <span for="organiserDropdown"> {{ t('league.details.upload.league.photo') }}
                    @if (inputForm.controls['imageMedium'].errors?.['required']) {
                      <span>*</span>
                    }
                  </span>
              @if (inputForm.controls['imageMedium'].touched) {
                @for (errorMessage of inputForm.controls['imageMedium']!.errors | errorMessages:'imageMedium';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }} </span>
                }
              }
            </div>
            <div class="mt-3">
              <app-drag-and-drop [selectedFile]="inputForm.value.imageMedium" (fileChange)="imageChange($event)" [isDisabled]="disableEditing"
                                 [useWithCropper]="true"/>
            </div>
          </div>
          <div class="col-12 col-xl-6 border-start border-md-start-0 ps-2 ps-xl-4 pt-xl-0 pt-3">
            <div class="field-title mt-3">
                  <span for="organiserDropdown"> {{ t('league.details.upload.league.logo') }}
                    @if (inputForm.controls['imageIcon'].errors?.['required']) {
                      <span>*</span>
                    }
                  </span>
              @if (inputForm.controls['imageIcon'].touched) {
                @for (errorMessage of inputForm.controls['imageIcon']!.errors | errorMessages:'imageIcon';track errorMessage) {
                  <span class="errorMes pt-1">{{ errorMessage }} </span>
                }
              }
            </div>
            <div class="mt-3">
              <app-drag-and-drop [selectedFile]="inputForm.value.imageIcon" (fileChange)="logoChange($event)" [isDisabled]="disableEditing"
                                 [useWithCropper]="true" [cropAreaWidth]="240" [cropAreaHeight]="240"/>
            </div>
          </div>
        </div>
      </app-admin-card-with-title>
      <ng-template #multiLangCard let-key="key" let-titleKey="titleKey" let-fieldTranslationKey="fieldTranslationKey">
        <app-admin-card-with-title [cardTitle]="t(titleKey)" [showToggleButton]="true">
          <app-language-input [isInput]="false" [inputForm]="$any(inputForm.get(key))"
                              [defaultLanguage]="inputForm.controls['defaultLanguage'].value"
                              [extraLanguages]="inputForm.controls['extraLanguages'].value"
                              [isRichText]="true"
                              [hrKey]="'hr'" [enKey]="'en'" [bsKey]="'bs'" [srKey]="'sr'" [itKey]="'it'" [siKey]="'sl'"
                              [hrLabel]="fieldTranslationKey + '.hr'" [enLabel]="fieldTranslationKey + '.en'" [itLabel]="fieldTranslationKey + '.it'"
                              [siLabel]="fieldTranslationKey + '.sl'" [srLabel]="fieldTranslationKey + '.sr'" [bsLabel]="fieldTranslationKey + '.bs'"/>
        </app-admin-card-with-title>
      </ng-template>

      <ng-template [ngTemplateOutlet]="multiLangCard" [ngTemplateOutletContext]="{ key: 'description', fieldTranslationKey: 'league.description', titleKey: 'league.details.description' }"/>
      <ng-template [ngTemplateOutlet]="multiLangCard" [ngTemplateOutletContext]="{ key: 'rules', fieldTranslationKey: 'league.rules', titleKey: 'league.details.rules' }"/>
      <ng-template [ngTemplateOutlet]="multiLangCard" [ngTemplateOutletContext]="{ key: 'generalInfo', fieldTranslationKey: 'league.generalInfo', titleKey: 'league.details.generalInfo' }"/>
      <ng-template [ngTemplateOutlet]="multiLangCard" [ngTemplateOutletContext]="{ key: 'scoringInfo', fieldTranslationKey: 'league.scoringInfo', titleKey: 'league.details.scoringInfo' }"/>

      <app-action-buttons-row [disableEditing]="disableEditing" (onSave)="onSave()"/>
    </div>
  </form>
</ng-container>
